import { Icon } from '@components';
import variaveisAmbiente from './VariaveisAmbiente';
import exclusaoDados from './ExclusaoDados';

export default [
  {
    path: '/indicadores',
    icon: Icon.LineChartOutlined,
    text: 'Indicadores',
    match: /\/indicadores+$/,
    exact: true,
    sider: true,
  },
  ...exclusaoDados,
  ...variaveisAmbiente,
];
